<template>
  <div>
    <card>
      <div slot="header" class='toolsBar'>
        <div class="leftTools" />
        <div>
          <l-button type="info" @click="handlenew()" class='text-right'>新增</l-button>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <el-table :data="tableData">
            <el-table-column prop="name" label="名稱" />
            <el-table-column prop="title" label="顯示名稱" />
            <el-table-column label="ISO Code">
              <div slot-scope="props">
                <b>{{props.row.isoCode}}</b>
              </div>
            </el-table-column>
            <el-table-column label="Actions">
              <div class="td-actions" slot-scope="props">
                <a v-tooltip.top-center="'編輯'" class="btn btn-default btn-link btn-xs" @click="handleEdit(props.row)">
                  <i class="fa fa-edit" />
                </a>
                <a v-tooltip.top-center="'刪除'" class="btn btn-danger btn-link btn-xs" @click="handleDelete(props.row.id, props)" >
                  <i class="fa fa-close" style='color:red' />
                </a>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <div class="">
          <p class="card-category" />
        </div>
        <l-pagination class="pagination-no-border"
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      @input='handleIndexChange'
                      :total="pagination.total" />
      </div>
    </card>
    <el-dialog
      center
      :title="getTitle()"
      :visible.sync="modals.custom">

      <fg-input label="名稱"
                type="text"
                name="link"
                data-vv-as="名稱"
                v-model="form.name"
                v-validate="'required'"     
                :error="getError('name')"
                required />

      <fg-input label="顯示名稱"
                type="text"
                name="title"
                data-vv-as="顯示名稱"
                v-model="form.title"
                v-validate="'required'"    
                :error="getError('title')"
                required />
      
      <fg-input label="ISO Code" :error="getError('isoCode')">
        <el-select
          class="select-default"
          data-vv-as="ISO Code"
          placeholder="請選擇"
          name="isoCode"
          v-model="form.isoCode"
          :error="getError('isoCode')"
          v-validate="'required'">
          <el-option v-for="i in cCodes" class="select-default" :value="i" :label="i" :key="i" />
        </el-select>
      </fg-input>
      <div class="text-right">
        <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info align-right">送出</button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
 /* eslint-disable */ 
  import { Dialog, Table, TableColumn, MessageBox, Select, Option } from 'element-ui'
  import { Pagination as LPagination } from 'src/components/index'
  import lib from '../../../lib'
  import tools from '../../../tools'
  import currencyCodes from 'currency-codes'

  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [Dialog.name]: Dialog,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      LPagination
    },
    data() {
      return {
        pagination: {
          perPage: 10,
          currentPage: 1,
          total: 0
        },
        form: {
          id: '',
          name: '',
          title: '',
          isoCode: ''
        },
        searchForm: {
        },
        query: {
        },
        imageLoader:'',
        modals: {
          custom: false
        },
        tableData: [],

        cCodes: []
      }
    },
    async mounted() {
      await this.getData()
    },
    watch: {
    },
    computed: {
    },
    methods: {
      getTitle() {
        return (this.form.id == '')?'新增幣別':'編輯幣別'
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate() {
        var _this = this
        this.$validator.validateAll().then(isValid => {
          if (!isValid) return;
          _this.createAndUpdate()
        })
      },
      openModal(name) {
        this.modals[name] = true
      },
      closeModal(name) {
        this.modals[name] = false
      },
      async handlenew() {
        await this.clearForm()
        this.$validator.errors.clear()
        this.openModal('custom')
      },
      handleEdit(row) {
        this.form.id = row.id
        this.form.name = row.name
        this.form.title = row.title
        this.form.isoCode = row.isoCode
        this.openModal('custom')
      },
      async handleIndexChange(page) {
        await this.getData()
      },
      async getData() {
        this.query.offset = (this.pagination.currentPage - 1) * this.pagination.perPage
        this.query.limit = this.pagination.perPage
        var data = await lib.getCurrencyList(this.query)
        if (data.status == 0) {
          var result = data.result
          this.pagination.total = result.count
          this.tableData = result.currencies
        }

        if (this.cCodes.length === 0) {
          this.cCodes = currencyCodes.codes()
        }
      },
      async clearForm() {
        var _this = this
        return new Promise(function(resolve, reject) {
          _this.form.id = ''
          _this.form.name = ''
          _this.form.title = ''
          _this.form.isoCode = ''
          resolve()
        })
      },
      async createAndUpdate() {
        var actionText = ''
        if (this.form.id === '') {
          var data = await lib.createCurrency(this.form)
          actionText = '新增'
        } else {
          var data = await lib.updateCurrency(this.form.id, this.form);
          actionText = '更新'
        }
        if (data.status == 0) {
          await this.getData()
          this.closeModal('custom')
          this.$swal(`${actionText}成功`, '', 'success')
        } else if (data.status == 7) {
           this.$swal('Page Alias重複', '', 'error')
        } else {
          this.$swal(`${actionText}失敗`, '', 'error')
        }
      },
      async handleDelete(id, porp) {
        var result = await tools.confirmDialog(this, "確定要刪除?")
        if (result) {
          var data = await lib.deleteBanner(id)
          if (data.status == 0) {
            await this.getData()
            this.$swal('已刪除', '', 'success')
          } else {
            this.$swal('刪除失敗', '', 'error')
          }
        }
      }
    }
  }
</script>


<style>
.toolsBar {
  justify-content: space-between;
  display: flex;
}

.leftTools {
  display: flex;
}


.leftTools > * {
  padding-right: 10px;
}

.imageCol > img {
  height: 150px;
}
</style>
